/**
 * SkinVault — Combined Product + Cart JS (Optimized)
 * ===================================================================
 * Merged from:
 *   1. skinvault-sticky-bar.js   (sticky bar, gallery, banners, etc.)
 *   2. theme.liquid inline script (quantity limiter, cart hijacks)
 *
 * Key optimizations vs originals:
 *   - getUnitPrice() deduplicated (was defined twice)
 *   - 6 concurrent setInterval polls → 1 unified tick + MutationObservers
 *   - Inline qty-limit script merged here (removed from theme.liquid)
 *   - Guard flags prevent duplicate initialization
 */

(function () {
  'use strict';

  /* =================================================================
     SHARED CONFIG
     ================================================================= */
  var MAX_QTY = 3;
  var LIMIT_MSG = 'Sorry! Maximum of ' + MAX_QTY + ' per purchase.';
  var attemptedOver = {};


  /* =================================================================
     SHARED HELPERS
     ================================================================= */

  /** Read the current unit price from the (visually-hidden) price element */
  function getUnitPrice() {
    var el = document.querySelector('.product-price .price') ||
             document.querySelector('.product-price');
    var text = el ? el.textContent.replace(/[^0-9.]/g, '') : '0';
    return parseFloat(text) || 0;
  }

  /** Format a dollar amount: $55 or $55.50 */
  function formatPrice(amount) {
    return (amount % 1 === 0) ? '$' + amount : '$' + amount.toFixed(2);
  }

  /** Get a unique key for a qty wrapper (for attemptedOver tracking) */
  function getWrapperId(wrapper) {
    var input = wrapper ? wrapper.querySelector('input') : null;
    return input ? (input.id || input.name || 'unknown') : 'unknown';
  }


  /* =================================================================
     PART A — QUANTITY LIMITER  (was inline in theme.liquid)
     ================================================================= */

  // --- Toast notification for collection/quick-add pages ---
  function showToast(message) {
    var existing = document.getElementById('qty-limit-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'qty-limit-toast';
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);' +
      'background:#c0392b;color:#fff;padding:12px 24px;border-radius:6px;font-size:14px;' +
      'font-weight:500;z-index:999999;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s;';
    document.body.appendChild(toast);
    setTimeout(function () {
      toast.style.opacity = '0';
      setTimeout(function () { toast.remove(); }, 300);
    }, 3500);
  }

  function showMsg(wrapper) {
    var quantityLi = wrapper.closest('.quantity-product');
    if (quantityLi) {
      var ul = quantityLi.closest('.wrap-quantity-add-cart');
      if (ul && !ul.querySelector('.qty-limit-msg')) {
        var msg = document.createElement('div');
        msg.className = 'qty-limit-msg';
        msg.textContent = LIMIT_MSG;
        msg.style.cssText = 'color:#c0392b;font-size:12px;margin-top:4px;margin-bottom:8px;font-weight:500;list-style:none;';
        quantityLi.after(msg);
      }
      return;
    }
    var cartCell = wrapper.closest('td');
    if (cartCell) {
      if (cartCell.querySelector('.qty-limit-msg')) return;
      var msg2 = document.createElement('div');
      msg2.className = 'qty-limit-msg';
      msg2.textContent = LIMIT_MSG;
      msg2.style.cssText = 'color:#c0392b;font-size:12px;margin-top:6px;text-align:center;font-weight:500;';
      cartCell.appendChild(msg2);
    }
  }

  function hideMsg(wrapper) {
    var quantityLi = wrapper.closest('.quantity-product');
    if (quantityLi) {
      var ul = quantityLi.closest('.wrap-quantity-add-cart');
      if (ul) { var m = ul.querySelector('.qty-limit-msg'); if (m) m.remove(); }
      return;
    }
    var cartCell = wrapper.closest('td');
    if (cartCell) { var m2 = cartCell.querySelector('.qty-limit-msg'); if (m2) m2.remove(); }
  }

  function styleBtn(plusBtn, atLimit) {
    if (!plusBtn) return;
    plusBtn.style.opacity = atLimit ? '0.3' : '';
    plusBtn.style.cursor = atLimit ? 'not-allowed' : '';
  }

  // --- Block ATC on product page if over limit ---
  function blockAddToCartIfOverLimit() {
    var addBtn = document.getElementById('add-to-cart');
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!addBtn || !form || addBtn.dataset.limitHijacked) return;
    addBtn.dataset.limitHijacked = 'true';

    var originalSubmitHandlers = [];
    if (typeof jQuery !== 'undefined') {
      var formEvents = jQuery._data(form, 'events');
      if (formEvents && formEvents.submit) {
        formEvents.submit.forEach(function (h) { originalSubmitHandlers.push(h.handler); });
      }
      jQuery(form).off('submit');
    }

    var originalClickHandler = null;
    if (typeof jQuery !== 'undefined') {
      var bodyEvents = jQuery._data(document.body, 'events');
      if (bodyEvents && bodyEvents.click) {
        bodyEvents.click.forEach(function (h) {
          if (h.selector === '.add-to-cart') originalClickHandler = h.handler;
        });
        jQuery(document.body).off('click', '.add-to-cart');
      }
    }

    jQuery(document.body).on('click', '.add-to-cart', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = this;
      var qtyInput = document.getElementById('quantity');
      var requestedQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Checking...';

      jQuery.getJSON('/cart.js', function (cart) {
        var formData = new FormData(form);
        var variantId = formData.get('id');
        var inCart = 0;
        cart.items.forEach(function (item) {
          if (String(item.variant_id) === String(variantId)) inCart = item.quantity;
        });

        var totalWouldBe = inCart + requestedQty;
        if (totalWouldBe > MAX_QTY) {
          var canAdd = MAX_QTY - inCart;
          btn.disabled = false;
          btn.textContent = originalText;

          var wrapper = document.querySelector('.qty-wrapper');
          if (canAdd <= 0) {
            attemptedOver[getWrapperId(wrapper)] = true;
            showMsg(wrapper);
            var ul = wrapper.closest('.wrap-quantity-add-cart') || wrapper.closest('td');
            if (ul) {
              var msg = ul.querySelector('.qty-limit-msg');
              if (msg) msg.textContent = 'Sorry! There is a maximum of ' + MAX_QTY + ' per purchase.';
            }
          } else {
            if (qtyInput) qtyInput.value = canAdd;
            runOriginal(btn, e);
          }
        } else {
          btn.disabled = false;
          btn.textContent = originalText;
          runOriginal(btn, e);
        }
      }).fail(function () {
        btn.disabled = false;
        btn.textContent = originalText;
        runOriginal(btn, e);
      });

      function runOriginal(b, ev) {
        // 1. Use captured handler if we got it at init time
        if (originalClickHandler) {
          originalClickHandler.call(b, ev);
          return;
        }
        // 2. Fallback: theme exposes addToCart globally (same AJAX handler)
        if (typeof window.addToCart === 'function') {
          window.addToCart.call(b, ev);
          return;
        }
        // 3. Last resort: try any current body .add-to-cart handler that isn't ours
        var bodyEv = jQuery._data(document.body, 'events');
        if (bodyEv && bodyEv.click) {
          for (var i = 0; i < bodyEv.click.length; i++) {
            var h = bodyEv.click[i];
            if (h.selector === '.add-to-cart' && h.handler.toString().indexOf('Checking') === -1) {
              h.handler.call(b, ev);
              return;
            }
          }
        }
        // 4. Absolute last resort: native form submit (will redirect to /cart)
        originalSubmitHandlers.forEach(function (h) { jQuery(form).on('submit', h); });
        jQuery(form).submit();
      }
    });
  }

  // --- Hijack quick-add on collection pages ---
  function hijackQuickAdd() {
    if (typeof jQuery === 'undefined') return;
    if (document.getElementById('add-to-cart')) return;

    var bodyEvents = jQuery._data(document.body, 'events');
    if (!bodyEvents || !bodyEvents.click) return;

    var originalHandler = null;
    bodyEvents.click.forEach(function (h) {
      if (h.selector === '.add-to-cart') {
        var src = h.handler.toString();
        if (src.indexOf('qty-limit-toast') !== -1 || src.indexOf('quickAddHijacked') !== -1) return;
        originalHandler = h.handler;
      }
    });
    if (!originalHandler) return;

    jQuery(document.body).off('click', '.add-to-cart');
    jQuery(document.body).on('click', '.add-to-cart', function (e) {
      e.quickAddHijacked = true;
      e.preventDefault();
      e.stopImmediatePropagation();

      var btn = this;
      if (btn.disabled) return;

      var productWrapper = btn.closest('.product-wrapper') || btn.closest('.product-item');
      var titleEl = productWrapper
        ? (productWrapper.querySelector('.product-title a') || productWrapper.querySelector('.product-title') ||
           productWrapper.querySelector('h3') || productWrapper.querySelector('h4'))
        : null;
      var productTitle = titleEl ? titleEl.textContent.trim() : 'this item';

      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.5';

      jQuery.getJSON('/cart.js', function (cart) {
        btn.style.pointerEvents = '';
        btn.style.opacity = '';

        var realAjax = jQuery.ajax;
        var intercepted = false;

        jQuery.ajax = function (url, settings) {
          var opts = typeof url === 'string' ? (settings || {}) : url;
          var reqUrl = typeof url === 'string' ? url : opts.url;
          jQuery.ajax = realAjax;
          intercepted = true;

          if (reqUrl && reqUrl.indexOf('/cart/add') !== -1) {
            var data = opts.data;
            var variantId = null;
            if (typeof data === 'string') {
              var match = data.match(/id=(\d+)/);
              if (match) variantId = match[1];
              try { var parsed = JSON.parse(data); if (parsed.id) variantId = String(parsed.id); } catch (ex) {}
            } else if (typeof data === 'object' && data) {
              variantId = String(data.id);
            }
            if (variantId) {
              var inCart = 0;
              cart.items.forEach(function (item) {
                if (String(item.variant_id) === variantId) inCart = item.quantity;
              });
              if (inCart >= MAX_QTY) {
                showToast('Sorry! Maximum of ' + MAX_QTY + ' of ' + productTitle + ' per purchase.');
                return jQuery.Deferred().reject();
              }
            }
          }
          return typeof url === 'string' ? realAjax.call(this, url, opts) : realAjax.call(this, opts);
        };

        originalHandler.call(btn, e);
        setTimeout(function () { if (!intercepted) jQuery.ajax = realAjax; }, 1000);
      }).fail(function () {
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
        originalHandler.call(btn, e);
      });
    });
  }

  // --- Hijack cart page +/- buttons ---
  function hijackCartButtons() {
    if (typeof jQuery === 'undefined') return;

    jQuery('.qty-up, .qty--plus').each(function () {
      var btn = this;
      if (btn.dataset.hijacked) return;
      btn.dataset.hijacked = 'true';

      var originalHandlers = [];
      var events = jQuery._data(btn, 'events');
      if (events && events.click) {
        events.click.forEach(function (h) { originalHandlers.push(h.handler); });
      }
      jQuery(btn).off('click');

      jQuery(btn).on('click', function (e) {
        var wrapper = btn.closest('.qty-wrapper');
        if (!wrapper) return;
        var input = wrapper.querySelector('input');
        if (!input) return;
        var val = parseInt(input.value) || 0;

        if (val >= MAX_QTY) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.value = MAX_QTY;
          attemptedOver[getWrapperId(wrapper)] = true;
          showMsg(wrapper);
          styleBtn(btn, true);
          return false;
        }
        for (var i = 0; i < originalHandlers.length; i++) originalHandlers[i].call(btn, e);
        setTimeout(function () {
          if (parseInt(input.value) >= MAX_QTY) styleBtn(btn, true);
        }, 100);
      });
    });

    jQuery('.qty-down, .qty--minus').each(function () {
      var btn = this;
      if (btn.dataset.hijackedMinus) return;
      btn.dataset.hijackedMinus = 'true';
      jQuery(btn).on('click', function () {
        setTimeout(function () {
          var wrapper = btn.closest('.qty-wrapper');
          if (!wrapper) return;
          var input = wrapper.querySelector('input');
          if (!input) return;
          var val = parseInt(input.value) || 0;
          var plusBtn = wrapper.querySelector('.qty--plus, .qty-up');
          if (val < MAX_QTY) {
            attemptedOver[getWrapperId(wrapper)] = false;
            hideMsg(wrapper);
            styleBtn(plusBtn, false);
          }
        }, 200);
      });
    });
  }

  function enforceProductPage() {
    var wrappers = document.querySelectorAll('.qty-wrapper');
    wrappers.forEach(function (wrapper) {
      var input = wrapper.querySelector('input');
      if (!input) return;
      input.setAttribute('max', MAX_QTY);
      var val = parseInt(input.value) || 0;
      var plusBtn = wrapper.querySelector('.qty--plus, .qty-up');

      if (val > MAX_QTY) {
        input.value = MAX_QTY;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        attemptedOver[getWrapperId(wrapper)] = true;
        showMsg(wrapper);
      }
      styleBtn(plusBtn, val >= MAX_QTY);
      if (val < MAX_QTY && !attemptedOver[getWrapperId(wrapper)]) hideMsg(wrapper);
    });
  }

  // --- Global input listener for manual qty typing ---
  document.addEventListener('input', function (e) {
    var input = e.target;
    var wrapper = input.closest ? input.closest('.qty-wrapper') : null;
    if (!wrapper) return;
    if (parseInt(input.value) > MAX_QTY) {
      input.value = MAX_QTY;
      attemptedOver[getWrapperId(wrapper)] = true;
      showMsg(wrapper);
    }
  }, true);

  // --- Global jQuery.ajax interceptor (cap qty on cart endpoints) ---
  if (typeof jQuery !== 'undefined') {
    var originalAjax = jQuery.ajax;
    jQuery.ajax = function (url, settings) {
      var opts = typeof url === 'string' ? (settings || {}) : url;
      var reqUrl = typeof url === 'string' ? url : opts.url;

      if (reqUrl && (reqUrl.indexOf('/cart/change') !== -1 || reqUrl.indexOf('/cart/update') !== -1 || reqUrl.indexOf('/cart/add') !== -1)) {
        var data = opts.data;
        if (typeof data === 'string') {
          if (data.indexOf('quantity=') !== -1) {
            data = data.replace(/quantity=(\d+)/, function (match, num) {
              return 'quantity=' + Math.min(parseInt(num), MAX_QTY);
            });
            opts.data = data;
          }
          try {
            var jsonData = JSON.parse(data);
            if (jsonData.quantity && jsonData.quantity > MAX_QTY) {
              jsonData.quantity = MAX_QTY;
              opts.data = JSON.stringify(jsonData);
            }
          } catch (ex) {}
        }
        if (typeof data === 'object' && data !== null) {
          if (data.quantity && parseInt(data.quantity) > MAX_QTY) data.quantity = MAX_QTY;
          if (data.updates && Array.isArray(data.updates)) {
            data.updates = data.updates.map(function (q) { return Math.min(q, MAX_QTY); });
          }
        }
      }
      return typeof url === 'string' ? originalAjax.call(this, url, opts) : originalAjax.call(this, opts);
    };
  }

  // --- Global fetch interceptor ---
  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    if (typeof url === 'string' &&
        (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) &&
        options && options.body) {
      try {
        if (typeof options.body === 'string') {
          try {
            var body = JSON.parse(options.body);
            if (body.quantity && body.quantity > MAX_QTY) {
              body.quantity = MAX_QTY;
              options.body = JSON.stringify(body);
            }
          } catch (ex) {
            if (options.body.indexOf('quantity=') !== -1) {
              options.body = options.body.replace(/quantity=(\d+)/, function (m, n) {
                return 'quantity=' + Math.min(parseInt(n), MAX_QTY);
              });
            }
          }
        }
      } catch (ex2) {}
    }
    return originalFetch.apply(this, arguments);
  };

  // --- Prevent touchstart double-add on iPhone ---
  document.addEventListener('touchstart', function (e) {
    if (e.target.closest && e.target.closest('.add-to-cart')) {
      e.stopImmediatePropagation();
    }
  }, true);


  /* =================================================================
     PART B — STICKY BAR + PRODUCT PAGE FEATURES
     ================================================================= */

  // --- Sticky Add-to-Cart bar ---
  function initStickyBar() {
    var stickyBar = document.querySelector('.add-to-cart-sticky.cart-sticky-bottom');
    var mainAddToCart = document.querySelector('#add-to-cart');
    if (!stickyBar || !mainAddToCart) return;

    // Force the qty + button wrapper visible
    var wrapQty = stickyBar.querySelector('.wrap-quantity-add-cart');
    if (wrapQty) {
      wrapQty.style.setProperty('display', 'flex', 'important');
      wrapQty.style.setProperty('align-items', 'center', 'important');
      wrapQty.style.setProperty('justify-content', 'center', 'important');
      wrapQty.style.setProperty('gap', '0', 'important');
      wrapQty.style.setProperty('list-style', 'none', 'important');
      wrapQty.style.setProperty('padding', '0', 'important');
      wrapQty.style.setProperty('margin', '0', 'important');
      wrapQty.style.setProperty('width', 'auto', 'important');
    }

    // Dynamic pricing on sticky button
    var stickyBtn = stickyBar.querySelector('.sticky-add-to-cart .add-to-cart');
    var stickyQtyInput = stickyBar.querySelector('.item-quantity');

    function updateStickyButtonPrice() {
      if (!stickyBtn || !stickyQtyInput) return;
      if (mainAddToCart && mainAddToCart.disabled) {
        stickyBtn.textContent = 'Sold Out';
        stickyBtn.disabled = true;
        stickyBtn.classList.add('sv-sold-out');
        return;
      }
      stickyBtn.disabled = false;
      stickyBtn.classList.remove('sv-sold-out');
      var qty = parseInt(stickyQtyInput.value, 10) || 1;
      var total = getUnitPrice() * qty;
      stickyBtn.textContent = formatPrice(total) + ' \u2014 Add to Cart';
    }

    if (stickyQtyInput) {
      stickyQtyInput.addEventListener('input', updateStickyButtonPrice);
      stickyQtyInput.addEventListener('change', updateStickyButtonPrice);
    }
    updateStickyButtonPrice();

    // Enforce quantity limit on sticky bar
    if (stickyQtyInput) {
      function clampStickyQty() {
        var maxAttr = stickyQtyInput.getAttribute('max');
        if (!maxAttr) return;
        var maxQty = parseInt(maxAttr, 10);
        var currentQty = parseInt(stickyQtyInput.value, 10) || 1;
        if (currentQty > maxQty) {
          stickyQtyInput.value = maxQty;
          showStickyError(maxQty);
        }
      }
      stickyQtyInput.addEventListener('input', clampStickyQty);
      stickyQtyInput.addEventListener('change', clampStickyQty);
    }

    // Sticky error message
    var stickyErrorEl = null;
    var stickyErrorTimer = null;
    function showStickyError(maxQty) {
      if (!stickyErrorEl) {
        stickyErrorEl = document.createElement('div');
        stickyErrorEl.className = 'sv-sticky-error';
        stickyBar.parentNode.insertBefore(stickyErrorEl, stickyBar);
      }
      stickyErrorEl.textContent = 'Sorry! Maximum of ' + maxQty + ' per purchase.';
      stickyErrorEl.style.display = 'block';
      clearTimeout(stickyErrorTimer);
      stickyErrorTimer = setTimeout(function () {
        if (stickyErrorEl) stickyErrorEl.style.display = 'none';
      }, 3000);
    }

    // Block ATC click if over max
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        var maxAttr = stickyQtyInput ? stickyQtyInput.getAttribute('max') : null;
        if (!maxAttr) return;
        var maxQty = parseInt(maxAttr, 10);
        var currentQty = parseInt(stickyQtyInput.value, 10) || 1;
        if (currentQty > maxQty) {
          e.stopImmediatePropagation();
          e.preventDefault();
          stickyQtyInput.value = maxQty;
          showStickyError(maxQty);
        }
      }, true);
    }

    // Show/hide based on main ATC visibility (rAF-throttled scroll)
    stickyBar.style.setProperty('display', 'flex', 'important');
    stickyBar.classList.add('sv-sticky-visible');

    function updateVisibility() {
      var rect = mainAddToCart.getBoundingClientRect();
      var isMainVisible = rect.top < window.innerHeight && rect.bottom > 0;
      stickyBar.classList.toggle('sv-sticky-hidden', isMainVisible);
      stickyBar.classList.toggle('sv-sticky-visible', !isMainVisible);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { updateVisibility(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });
    updateVisibility();

    // Return refs for the unified tick
    return {
      updateStickyButtonPrice: updateStickyButtonPrice,
      clampStickyQty: stickyQtyInput ? function () {
        var maxAttr = stickyQtyInput.getAttribute('max');
        if (!maxAttr) return;
        var maxQty = parseInt(maxAttr, 10);
        if ((parseInt(stickyQtyInput.value, 10) || 1) > maxQty) {
          stickyQtyInput.value = maxQty;
        }
      } : null
    };
  }

  // --- Main product page: dynamic pricing on ATC button ---
  function initMainButton() {
    var mainBtn = document.querySelector('#add-to-cart');
    var mainQty = document.querySelector('#col-main input.item-quantity');
    if (!mainBtn || !mainQty) return null;

    function updateMainPrice() {
      if (mainBtn.disabled) {
        mainBtn.textContent = 'Sold Out';
        mainBtn.classList.add('sv-sold-out');
        return;
      }
      mainBtn.classList.remove('sv-sold-out');
      var qty = parseInt(mainQty.value, 10) || 1;
      var total = getUnitPrice() * qty;
      mainBtn.textContent = formatPrice(total) + ' \u2014 Add to Cart';

      var ap = document.querySelector('afterpay-placement');
      if (ap) ap.setAttribute('data-amount', String(total));
    }

    mainQty.addEventListener('input', updateMainPrice);
    mainQty.addEventListener('change', updateMainPrice);
    updateMainPrice();

    return { updateMainPrice: updateMainPrice };
  }

  // --- Move Afterpay callout below ATC unit ---
  function moveAfterpay() {
    var wrapQtyCart = document.querySelector('#col-main .wrap-quantity-add-cart');
    if (!wrapQtyCart) return false;

    var mobileAfterpay = document.querySelector('.product-info.d-lg-none .group-price-sale afterpay-placement');
    var desktopAfterpay = document.querySelector('.d-none.d-lg-block .group-price-sale afterpay-placement');
    if (!mobileAfterpay && !desktopAfterpay) return false;

    var toMove = mobileAfterpay || desktopAfterpay;
    if (toMove) {
      toMove.classList.add('sv-afterpay-moved');
      wrapQtyCart.parentNode.insertBefore(toMove, wrapQtyCart.nextSibling);
    }
    var remaining = mobileAfterpay ? desktopAfterpay : null;
    if (remaining) remaining.style.display = 'none';
    return true;
  }

  // --- Watch & deduplicate qty-limit-msg (theme injects new ones on every click) ---
  function watchQtyLimitMsg() {
    var wrapQtyCart = document.querySelector('#col-main .wrap-quantity-add-cart');
    if (!wrapQtyCart) return;

    var movedMsg = null;

    function tryMove() {
      var allMsgs = wrapQtyCart.querySelectorAll('.qty-limit-msg');
      var parent = wrapQtyCart.parentNode;
      var outsideMsgs = parent.querySelectorAll(':scope > .qty-limit-msg');
      if (allMsgs.length === 0 && outsideMsgs.length === 0) return;

      if (!movedMsg) {
        movedMsg = allMsgs[0] || outsideMsgs[0];
        movedMsg.classList.add('sv-qty-limit-moved');
        parent.insertBefore(movedMsg, wrapQtyCart.nextSibling);
      }
      allMsgs.forEach(function (msg) { if (msg !== movedMsg) msg.remove(); });
      outsideMsgs.forEach(function (msg) { if (msg !== movedMsg) msg.remove(); });
    }

    tryMove();
    var observer = new MutationObserver(function () { tryMove(); });
    observer.observe(wrapQtyCart, { childList: true, subtree: true });
    observer.observe(wrapQtyCart.parentNode, { childList: true });
  }

  // --- Backorder info banner ---
  function initBackorderNotice() {
    var BACKORDER_REGEX = /\s*\[Backorder\s+Ships\s+In\s+(\d+\+?\s*Days?)\]/i;

    var allH1 = document.querySelectorAll('h1.page-heading');
    var shippingNum = '';
    allH1.forEach(function (h1) {
      var match = h1.textContent.match(BACKORDER_REGEX);
      if (match) {
        shippingNum = match[1].replace(/\s*days?/i, '').replace(/\+/, '');
        h1.textContent = h1.textContent.replace(BACKORDER_REGEX, '');
      }
    });
    if (!shippingNum) return;

    var breadcrumbItems = document.querySelectorAll('.breadcrumb li');
    breadcrumbItems.forEach(function (li) {
      var walk = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walk.nextNode())) {
        if (BACKORDER_REGEX.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(BACKORDER_REGEX, '');
        }
      }
    });

    document.title = document.title.replace(BACKORDER_REGEX, '');

    if (!document.querySelector('.sv-backorder-banner')) {
      var atcWrap = document.querySelector('.wrap-quantity-add-cart');
      if (atcWrap) {
        var banner = document.createElement('div');
        banner.className = 'sv-backorder-banner';
        banner.innerHTML =
          '<div class="sv-backorder-banner-inner">' +
            '<span class="sv-backorder-banner-icon">&#128230;</span>' +
            '<div class="sv-backorder-banner-text">' +
              '<strong>This item is on its way to us</strong>' +
              '<span>Order now to secure yours \u2014 we\u2019ll ship it as soon as it arrives, typically in about ' + shippingNum + ' days.</span>' +
            '</div>' +
          '</div>';
        atcWrap.parentNode.insertBefore(banner, atcWrap);
      }
    }
  }

  // --- Pre-order info banner ---
  function initPreOrderNotice() {
    var PREORDER_REGEX = /\s*\[Pre-?Order\s*([^\]]*)\]/i;

    // Per-product copy overrides, keyed by product handle.
    // Products not listed here get the generic message built from the [Pre-Order <date>] tag.
    var PREORDER_CUSTOM_COPY = {
      'skinceuticals-c-e-ferulic': {
        heading: 'A new C E Ferulic is coming August 5th!',
        detail: 'A new boosted formula, stronger science, and better results coming soon! Pre-Order now to guarantee your delivery soon after release!'
      }
    };

    var allH1 = document.querySelectorAll('h1.page-heading');
    var releaseDate = '';
    var foundPreOrder = false;
    allH1.forEach(function (h1) {
      var match = h1.textContent.match(PREORDER_REGEX);
      if (match) {
        foundPreOrder = true;
        releaseDate = (match[1] || '').trim();
        h1.textContent = h1.textContent.replace(PREORDER_REGEX, '');
      }
    });
    if (!foundPreOrder) return;

    var breadcrumbItems = document.querySelectorAll('.breadcrumb li');
    breadcrumbItems.forEach(function (li) {
      var walk = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walk.nextNode())) {
        if (PREORDER_REGEX.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.replace(PREORDER_REGEX, '');
        }
      }
    });

    document.title = document.title.replace(PREORDER_REGEX, '');

    if (!document.querySelector('.sv-preorder-banner')) {
      var atcWrap = document.querySelector('.wrap-quantity-add-cart');
      if (atcWrap) {
        var handleMatch = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        var custom = handleMatch ? PREORDER_CUSTOM_COPY[handleMatch[1]] : null;
        var heading, detail;
        if (custom) {
          heading = custom.heading;
          detail = custom.detail;
        } else {
          var safeDate = releaseDate.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          heading = 'This item is available for pre-order';
          detail = safeDate
            ? 'Estimated release on ' + safeDate + ' — we’ll ship your order soon after.'
            : 'We’ll ship your order as soon as it’s released.';
        }
        var banner = document.createElement('div');
        banner.className = 'sv-preorder-banner';
        banner.innerHTML =
          '<div class="sv-preorder-banner-inner">' +
            '<span class="sv-preorder-banner-icon">&#128197;</span>' +
            '<div class="sv-preorder-banner-text">' +
              '<strong>' + heading + '</strong>' +
              '<span>' + detail + '</span>' +
            '</div>' +
          '</div>';
        atcWrap.parentNode.insertBefore(banner, atcWrap);
      }
    }
  }

  // --- In-stock banner ---
  function initInStockNotice() {
    if (document.querySelector('.sv-backorder-banner')) return;
    if (document.querySelector('.sv-preorder-banner')) return;
    if (document.querySelector('.sv-instock-banner')) return;
    if (!document.body.classList.contains('templateProduct')) return;

    var mainAtcBtn = document.getElementById('add-to-cart');
    if (mainAtcBtn && (mainAtcBtn.disabled || mainAtcBtn.classList.contains('sold-out'))) return;

    var productWrapper = document.querySelector('.product-content-wrapper');
    var atcWrap = productWrapper ? productWrapper.querySelector('.wrap-quantity-add-cart') : null;
    if (!atcWrap) return;

    var banner = document.createElement('div');
    banner.className = 'sv-instock-banner';
    banner.innerHTML =
      '<div class="sv-instock-banner-inner">' +
        '<span class="sv-instock-banner-icon">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3a7d44" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M20 6L9 17l-5-5"/>' +
          '</svg>' +
        '</span>' +
        '<div class="sv-instock-banner-text">' +
          '<strong>In Stock \u2014 Ready to Ship</strong>' +
        '</div>' +
      '</div>';
    atcWrap.parentNode.insertBefore(banner, atcWrap);

    if (mainAtcBtn) {
      function toggleBanner() {
        var isSoldOut = mainAtcBtn.classList.contains('sv-sold-out') ||
                        mainAtcBtn.classList.contains('sold-out') ||
                        mainAtcBtn.disabled;
        banner.style.display = isSoldOut ? 'none' : '';
      }
      toggleBanner();
      new MutationObserver(toggleBanner).observe(mainAtcBtn, { attributes: true, attributeFilter: ['class', 'disabled'] });
    }
  }

  // --- Collection pages & modal cross-sell: strip backorder/pre-order text from titles ---
  var BACKORDER_REGEX_GLOBAL = /\s*\[Backorder\s+Ships\s+In\s+\d+\+?\s*Days?\]/gi;
  var PREORDER_REGEX_GLOBAL = /\s*\[Pre-?Order[^\]]*\]/gi;

  function stripTitleTags(text) {
    return text.replace(BACKORDER_REGEX_GLOBAL, '').replace(PREORDER_REGEX_GLOBAL, '');
  }

  function cleanCollectionCards() {
    document.querySelectorAll('h5.product-name a').forEach(function (a) {
      var cleaned = stripTitleTags(a.textContent);
      if (cleaned !== a.textContent) a.textContent = cleaned;
    });
  }

  function cleanModalCrossSellTitles() {
    var related = document.querySelector('.layer-addcart-modal .layer-related-wrapper');
    if (!related) return;
    related.querySelectorAll('a').forEach(function (a) {
      var cleaned = stripTitleTags(a.textContent);
      if (cleaned !== a.textContent) a.textContent = cleaned;
    });
  }

  // --- Mobile: move modal close button to body so position:fixed works ---
  // The overlay has a CSS transform which creates a new containing block,
  // breaking position:fixed for any descendant. Moving to body fixes this.
  function fixMobileModalClose() {
    if (window.innerWidth > 767) return;
    var overlay = document.querySelector('.layer-addcart-modal.show');
    if (!overlay) return;
    var close = overlay.querySelector('.am-close');
    if (!close || close.parentElement === document.body) return;
    // Store original parent so we can put it back when modal closes
    close._svOriginalParent = close.parentElement;
    close._svOriginalNext = close.nextSibling;
    document.body.appendChild(close);
    close.classList.add('sv-mobile-close');
  }

  function restoreMobileModalClose() {
    var close = document.querySelector('body > .am-close.sv-mobile-close');
    if (!close || !close._svOriginalParent) return;
    close._svOriginalParent.insertBefore(close, close._svOriginalNext || null);
    close.classList.remove('sv-mobile-close');
  }

  // Watch for the cart modal appearing: clean titles + fix mobile close
  (function observeCartModal() {
    var modal = document.querySelector('.layer-addcart-modal');
    if (!modal) return;
    var obs = new MutationObserver(function () {
      cleanModalCrossSellTitles();
      if (modal.classList.contains('show')) {
        fixMobileModalClose();
      } else {
        restoreMobileModalClose();
      }
    });
    obs.observe(modal, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  })();

  // --- SkinCeuticals trust box ---
  function initSkinCeuticalsTrust() {
    var url = window.location.href.toLowerCase();
    var breadcrumbs = document.querySelector('.breadcrumb');
    var isSC = /skinceuticals/i.test(url) || (breadcrumbs && /skinceuticals/i.test(breadcrumbs.textContent));
    if (!isSC) return;
    if (document.querySelector('.sv-trust-box')) return;

    var shopifyPayBtn = document.querySelector('.shopify-payment-button');
    if (!shopifyPayBtn) return;

    var trustBox = document.createElement('div');
    trustBox.className = 'sv-trust-box';
    trustBox.innerHTML =
      '<div class="sv-trust-box-inner">' +
        '<div class="sv-trust-row">' +
          '<div class="sv-trust-item">' +
            '<svg class="sv-trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>' +
            '<div class="sv-trust-text"><strong>Authorized Retailer</strong><span>Verified by SkinCeuticals</span></div>' +
          '</div>' +
          '<div class="sv-trust-item">' +
            '<svg class="sv-trust-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>' +
            '<div class="sv-trust-text"><strong>100% Authentic</strong><span>Guaranteed genuine</span></div>' +
          '</div>' +
        '</div>' +
        '<a class="sv-trust-link" href="https://www.skinceuticals.ca/en_CA/authorized-retailers/authorized-retailers.html" target="_blank" rel="noopener">' +
          'Verify us on SkinCeuticals.ca \u2192' +
        '</a>' +
      '</div>';
    shopifyPayBtn.parentNode.insertBefore(trustBox, shopifyPayBtn.nextSibling);
  }

  // --- Info card (shipping / gift / Canadian) ---
  function initInfoCard() {
    if (document.getElementById('sv-info-card')) return;
    var fomoContent = document.querySelector('.fomo-content.text-left');
    if (!fomoContent) return;

    fomoContent.style.display = 'none';
    var card = document.createElement('div');
    card.id = 'sv-info-card';
    card.innerHTML =
      '<div class="sv-info-row">' +
        '<div class="sv-info-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2A57B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 18H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10l4 4v7a1 1 0 0 1-1 1h-2"/><circle cx="7.5" cy="18" r="2"/><circle cx="14.5" cy="18" r="2"/><path d="M16 6h4l3 3v5a1 1 0 0 1-1 1h-1"/></svg></div>' +
        '<div class="sv-info-text"><span class="sv-info-label">Free Shipping</span><span class="sv-info-detail">On all orders $99+ \u00a0\u00b7\u00a0 <a href="/policies/shipping-policy">Shipping Details</a></span></div>' +
      '</div>' +
      '<div class="sv-info-divider"></div>' +
      '<div class="sv-info-row">' +
        '<div class="sv-info-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2A57B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg></div>' +
        '<div class="sv-info-text"><span class="sv-info-label">Free Gift with $750+ Purchase</span><span class="sv-info-detail">Vivier Vitamin C Scrub, a $60 value</span></div>' +
      '</div>' +
      '<div class="sv-info-divider"></div>' +
      '<div class="sv-info-row">' +
        '<div class="sv-info-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#C2A57B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C9.5 2 7 4 7 7.5c0 3 2.5 6.5 5 10.5 2.5-4 5-7.5 5-10.5C17 4 14.5 2 12 2z"/><path d="M10.5 7.5L11.5 5.5 12.5 7.5 14.5 7.5 13 8.8 13.5 10.5 12 9.5 10.5 10.5 11 8.8 9.5 7.5z"/></svg></div>' +
        '<div class="sv-info-text"><span class="sv-info-label">Canadian Owned &amp; Operated</span><span class="sv-info-detail">All prices in CAD \u00a0\u00b7\u00a0 Ships from Canada \u00a0\u00b7\u00a0 No duties</span></div>' +
      '</div>';

    var fomoHeader = fomoContent.closest('.fomo-header');
    if (fomoHeader) fomoHeader.style.display = 'none';

    var trustBox = document.querySelector('.sv-trust-box');
    var shopifyPayBtn = document.querySelector('.shopify-payment-button');
    if (trustBox) {
      trustBox.parentElement.insertBefore(card, trustBox.nextElementSibling);
    } else if (shopifyPayBtn) {
      shopifyPayBtn.parentElement.insertBefore(card, shopifyPayBtn.nextSibling);
    } else {
      fomoContent.parentElement.insertBefore(card, fomoContent.nextSibling);
    }
  }

  // --- Bidirectional quantity sync between main ATC and sticky bar ---
  function syncQuantities() {
    var mainQty = document.querySelector('#col-main input.item-quantity');
    var stickyBar = document.querySelector('.add-to-cart-sticky.cart-sticky-bottom');
    var stickyQty = stickyBar ? stickyBar.querySelector('.item-quantity') : null;
    if (!mainQty || !stickyQty) return;

    var syncing = false;

    function syncToSticky() {
      if (syncing) return;
      syncing = true;
      stickyQty.value = mainQty.value;
      stickyQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }
    function syncToMain() {
      if (syncing) return;
      syncing = true;
      mainQty.value = stickyQty.value;
      mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      syncing = false;
    }

    mainQty.addEventListener('input', syncToSticky);
    mainQty.addEventListener('change', syncToSticky);
    stickyQty.addEventListener('input', syncToMain);
    stickyQty.addEventListener('change', syncToMain);

    // Return refs for unified tick (catch programmatic +/- changes)
    return {
      lastMainVal: mainQty.value,
      lastStickyVal: stickyQty.value,
      tick: function () {
        if (syncing) return;
        if (mainQty.value !== this.lastMainVal) {
          this.lastMainVal = mainQty.value;
          if (stickyQty.value !== mainQty.value) {
            syncing = true; stickyQty.value = mainQty.value; syncing = false;
          }
          this.lastStickyVal = stickyQty.value;
        } else if (stickyQty.value !== this.lastStickyVal) {
          this.lastStickyVal = stickyQty.value;
          if (mainQty.value !== stickyQty.value) {
            syncing = true; mainQty.value = stickyQty.value; syncing = false;
          }
          this.lastMainVal = mainQty.value;
        }
      }
    };
  }

  // --- Fix SuperZoom lightbox on related-product images ---
  function fixRelatedProductZoom() {
    function clean() {
      var imgs = document.querySelectorAll('.related-items img.spzgrhsince, .related-carousel img.spzgrhsince');
      imgs.forEach(function (img) { img.classList.remove('spzgrhsince'); });
      document.querySelectorAll('.related-items [data-fancybox], .related-carousel [data-fancybox]').forEach(function (el) {
        el.removeAttribute('data-fancybox');
        el.removeAttribute('data-thumb');
      });
      return imgs.length;
    }
    clean();
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      clean();
      if (attempts >= 10) clearInterval(poll);
    }, 500);
  }

  // --- Product image gallery: thumbnails + lightbox ---
  function initProductGallery() {
    if (!document.body.classList.contains('templateProduct')) return;
    if (document.querySelector('.sv-thumb-strip')) return;

    var slideMain = document.getElementById('slide--main');
    if (!slideMain) return;

    var $slideMain = window.jQuery ? jQuery(slideMain) : null;
    var isSlick = slideMain.classList.contains('slick-initialized');

    if (!isSlick && window.innerWidth < 992) {
      if (!initProductGallery._retries) initProductGallery._retries = 0;
      if (initProductGallery._retries < 15) {
        initProductGallery._retries++;
        setTimeout(initProductGallery, 200);
        return;
      }
    }

    var items;
    if (isSlick) {
      var slickTrack = slideMain.querySelector('.slick-track');
      items = slickTrack
        ? slickTrack.querySelectorAll(':scope > .slick-slide:not(.slick-cloned) .item')
        : slideMain.querySelectorAll(':scope > .item');
    } else {
      items = slideMain.querySelectorAll(':scope > .item');
    }
    if (items.length <= 1) return;

    var allImages = [];
    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (img) allImages.push({ src: img.src, thumb: img.src.replace('_2048x2048', '_320x320') });
    });
    if (allImages.length <= 1) return;

    var nativeFilter = document.querySelector('.slider-filter');
    if (nativeFilter) nativeFilter.style.display = 'none';

    var currentIndex = 0;

    function openLightbox() {
      var fbItems = allImages.map(function (img) { return { src: img.src, type: 'image' }; });
      jQuery.fancybox.open(fbItems, { loop: true, buttons: ['close'], animationEffect: 'fade', transitionEffect: 'fade' }, currentIndex);
    }

    if (!isSlick) {
      var directItems = slideMain.querySelectorAll(':scope > .item');
      for (var i = 1; i < directItems.length; i++) directItems[i].style.display = 'none';
      if (window.jQuery) {
        directItems.forEach(function (item) {
          var z = item.querySelector('.img-zoom');
          if (z && jQuery(z).data('zoom')) { try { jQuery(z).trigger('zoom.destroy'); } catch (e) {} }
        });
      }
      directItems.forEach(function (item) {
        item.style.cursor = 'zoom-in';
        item.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openLightbox(); });
      });
    } else {
      function neutraliseSPZ() {
        slideMain.querySelectorAll('img.spzgrhsince').forEach(function (img) { img.classList.remove('spzgrhsince'); });
        slideMain.querySelectorAll('a.grHub_spz_supper_advance_lightbox, a[class*="grHub_spz"]').forEach(function (a) {
          while (a.firstChild) a.parentNode.insertBefore(a.firstChild, a);
          a.parentNode.removeChild(a);
        });
        document.querySelectorAll('.fancybox-container').forEach(function (fb) {
          if (fb.querySelector('[class*="spz"]') || fb.querySelector('[class*="grHub"]')) fb.parentNode.removeChild(fb);
        });
      }
      neutraliseSPZ();
      setTimeout(neutraliseSPZ, 1500);
      setTimeout(neutraliseSPZ, 3500);

      var _svImgTouchX = 0, _svImgTouchY = 0;
      document.addEventListener('touchstart', function (e) {
        if (e.target.closest('#slide--main .slick-slide')) {
          _svImgTouchX = e.touches[0].clientX;
          _svImgTouchY = e.touches[0].clientY;
        }
      }, true);
      document.addEventListener('touchend', function (e) {
        if (!e.target.closest('#slide--main .slick-slide')) return;
        if (e.target.closest('.sv-thumb')) return;
        var t = e.changedTouches[0];
        if (Math.abs(t.clientX - _svImgTouchX) > 10 || Math.abs(t.clientY - _svImgTouchY) > 10) return;
        e.preventDefault(); e.stopPropagation();
        openLightbox();
      }, true);

      var $slickList = jQuery(slideMain).find('.slick-list');
      if ($slickList.length) $slickList.on('click', function () { openLightbox(); });
      slideMain.querySelectorAll('.slick-slide .item').forEach(function (item) { item.style.cursor = 'zoom-in'; });
    }

    // Build thumbnail strip
    var thumbStrip = document.createElement('div');
    thumbStrip.className = 'sv-thumb-strip';

    function goToThumb(clickedIdx) {
      currentIndex = clickedIdx;
      var slickNow = slideMain.classList.contains('slick-initialized');
      if (slickNow) {
        jQuery(slideMain).slick('slickGoTo', clickedIdx);
      } else {
        slideMain.querySelectorAll(':scope > .item').forEach(function (item, i) {
          item.style.display = i === clickedIdx ? 'block' : 'none';
        });
      }
      thumbStrip.querySelectorAll('.sv-thumb').forEach(function (t, i) {
        t.classList.toggle('sv-thumb-active', i === clickedIdx);
      });
    }

    allImages.forEach(function (imgData, idx) {
      var thumb = document.createElement('div');
      thumb.className = 'sv-thumb' + (idx === 0 ? ' sv-thumb-active' : '');
      thumb.setAttribute('data-index', idx);
      thumb.setAttribute('role', 'button');
      thumb.onclick = function () { goToThumb(idx); return false; };
      var thumbImg = document.createElement('img');
      thumbImg.src = imgData.thumb;
      thumbImg.alt = 'Product image ' + (idx + 1);
      thumb.appendChild(thumbImg);
      thumbStrip.appendChild(thumb);
    });

    var _svThumbTouchY = 0, _svThumbTouchX = 0;
    document.addEventListener('touchstart', function (e) {
      var thumb = e.target.closest('.sv-thumb');
      if (thumb) { _svThumbTouchX = e.touches[0].clientX; _svThumbTouchY = e.touches[0].clientY; }
    }, true);
    document.addEventListener('touchend', function (e) {
      var thumb = e.target.closest('.sv-thumb');
      if (!thumb) return;
      var t = e.changedTouches[0];
      if (Math.abs(t.clientX - _svThumbTouchX) > 10 || Math.abs(t.clientY - _svThumbTouchY) > 10) return;
      e.preventDefault();
      var idx = parseInt(thumb.getAttribute('data-index'));
      if (!isNaN(idx)) goToThumb(idx);
    }, true);

    var sliderMain = document.querySelector('.slider-main-image');
    if (sliderMain) sliderMain.parentNode.insertBefore(thumbStrip, sliderMain.nextSibling);

    function bindSlickSync() {
      if (slideMain.classList.contains('slick-initialized')) {
        jQuery(slideMain).on('afterChange', function (event, slick, newIndex) {
          currentIndex = newIndex;
          thumbStrip.querySelectorAll('.sv-thumb').forEach(function (t, i) {
            t.classList.toggle('sv-thumb-active', i === newIndex);
          });
        });
        return true;
      }
      return false;
    }
    if (!bindSlickSync()) {
      var syncAttempts = 0;
      var syncPoll = setInterval(function () {
        syncAttempts++;
        if (bindSlickSync() || syncAttempts >= 15) clearInterval(syncPoll);
      }, 200);
    }
  }


  /* =================================================================
     MASTER INIT + UNIFIED TICK
     Instead of 6 separate setInterval calls, we use ONE interval
     at 300ms that runs all periodic checks.
     ================================================================= */

  function runAll() {
    // Part A: Quantity limiter
    enforceProductPage();
    hijackCartButtons();
    blockAddToCartIfOverLimit();
    hijackQuickAdd();

    // Part B: Product page features
    var stickyRefs = initStickyBar();
    var mainBtnRefs = initMainButton();
    initBackorderNotice();
    initPreOrderNotice();
    initInStockNotice();
    cleanCollectionCards();
    cleanModalCrossSellTitles();
    initSkinCeuticalsTrust();
    initInfoCard();
    initProductGallery();
    watchQtyLimitMsg();
    var syncRefs = syncQuantities();
    fixRelatedProductZoom();

    // Move afterpay (third-party, async — poll until found)
    if (!moveAfterpay()) {
      var apAttempts = 0;
      var apPoll = setInterval(function () {
        apAttempts++;
        if (moveAfterpay() || apAttempts >= 20) clearInterval(apPoll);
      }, 250);
    }

    // --- UNIFIED TICK (replaces 6 separate setInterval calls) ---
    // Runs at 300ms — handles: qty enforcement, cart button hijack,
    // ATC block, sticky price, main price, qty sync.
    setInterval(function () {
      // Qty limiter checks
      enforceProductPage();
      hijackCartButtons();
      blockAddToCartIfOverLimit();

      // Sticky bar price + clamp
      if (stickyRefs) {
        stickyRefs.updateStickyButtonPrice();
        if (stickyRefs.clampStickyQty) stickyRefs.clampStickyQty();
      }

      // Main button price
      if (mainBtnRefs) mainBtnRefs.updateMainPrice();

      // Qty sync between main + sticky
      if (syncRefs) syncRefs.tick();
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();


/* ==========================================================================
   CART PAGE (/cart) — Rename buttons, heading, sticky bar, Afterpay sync
   Giftbox clones the original <input name="checkout"> so we need to catch
   the clone after it appears. We also rename the mobile-fixed sticky <a>.
   ========================================================================== */
(function() {
  if (!document.body.classList.contains('templateCart')) return;

  /* --- 1. Rename checkout buttons to "Proceed to Checkout" --- */
  function renameCheckoutBtns() {
    document.querySelectorAll(
      '.page-cart input[name="checkout"], ' +
      '.page-cart .giftbox-checkout, ' +
      '.mobile-fixed-wrap .giftbox-checkout'
    ).forEach(function(btn) {
      var target = 'Proceed to Checkout';
      var current = btn.tagName === 'INPUT' ? btn.value : btn.textContent;
      if (current && current.trim() !== target) {
        if (btn.tagName === 'INPUT') btn.value = target;
        else btn.textContent = target;
      }
    });
  }

  renameCheckoutBtns();

  var checkoutWrapper = document.querySelector('.page-cart .checkout-wrapper');
  if (checkoutWrapper) {
    new MutationObserver(function() { renameCheckoutBtns(); })
      .observe(checkoutWrapper, { childList: true, subtree: true });
  }

  var mobileWrap = document.querySelector('.mobile-fixed-wrap');
  if (mobileWrap) {
    new MutationObserver(function() { renameCheckoutBtns(); })
      .observe(mobileWrap, { childList: true, subtree: true });
  }

  setTimeout(renameCheckoutBtns, 1000);
  setTimeout(renameCheckoutBtns, 3000);

  /* --- 1b. Create X remove buttons inside qty-wrapper (matches +/- circles) --- */
  document.querySelectorAll('.page-cart .item-qty .wrapper-fix').forEach(function(wf) {
    var qtyWrapper = wf.querySelector('.qty-wrapper');
    var action2 = wf.querySelector('.action-2');
    if (qtyWrapper && action2) {
      var removeBtn = action2.querySelector('.cart-remove-btn');
      if (removeBtn) {
        var xSpan = document.createElement('span');
        xSpan.className = 'qty-inner sv-x-wrapper';
        var xCircle = document.createElement('a');
        xCircle.href = removeBtn.href;
        xCircle.className = 'sv-cart-x-circle qty-circle';
        xCircle.textContent = '';
        xSpan.appendChild(xCircle);
        qtyWrapper.appendChild(xSpan);
      }
    }
  });

  /* --- 2. Add "Items In Your Cart" heading above product table --- */
  var table = document.querySelector('.page-cart .col-lg-9 table');
  if (table && !document.getElementById('sv-cart-items-heading')) {
    var heading = document.createElement('h2');
    heading.id = 'sv-cart-items-heading';
    heading.textContent = 'Items In Your Cart';
    table.parentElement.insertBefore(heading, table);
  }

  /* --- 3. Create sticky checkout bar --- */
  var bar = document.createElement('div');
  bar.id = 'sv-cart-sticky-bar';
  bar.className = 'sv-cart-sticky-hidden';
  var inner = document.createElement('div');
  inner.className = 'sv-cart-sticky-inner';
  var totalDiv = document.createElement('div');
  totalDiv.className = 'sv-cart-sticky-total';
  var stickyBtn = document.createElement('button');
  stickyBtn.className = 'sv-cart-sticky-checkout';
  stickyBtn.textContent = 'Proceed to Checkout';
  stickyBtn.addEventListener('click', function() { window.location.href = '/checkout'; });
  inner.appendChild(totalDiv);
  inner.appendChild(stickyBtn);
  bar.appendChild(inner);
  document.body.appendChild(bar);

  /* --- 4. Populate sticky bar total + observe docapp changes --- */
  function updateStickyTotal() {
    var totalRow = document.querySelector('.col-lg-3 .docapp-est-total .docapp-right');
    if (totalRow && totalDiv) totalDiv.textContent = 'Total: ' + totalRow.textContent.trim();
  }
  updateStickyTotal();

  var docapp = document.querySelector('.col-lg-3 .docapp-cart-with-coupon-summary');
  if (docapp) {
    new MutationObserver(updateStickyTotal)
      .observe(docapp, { childList: true, subtree: true, characterData: true });
  }

  /* --- 5. Show/hide sticky bar based on checkout button visibility --- */
  var checkoutBtn = document.querySelector('.page-cart .checkout-wrapper input[name="checkout"]:nth-of-type(2)')
    || document.querySelector('.page-cart .col-lg-3 .checkout-wrapper');

  function updateVis() {
    if (!checkoutBtn) return;
    var rect = checkoutBtn.getBoundingClientRect();
    var vis = rect.top < window.innerHeight && rect.bottom > 0;
    bar.classList.toggle('sv-cart-sticky-hidden', vis);
    bar.classList.toggle('sv-cart-sticky-visible', !vis);
  }

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() { updateVis(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
  window.addEventListener('resize', updateVis, { passive: true });
  updateVis();

  /* --- 6. Afterpay dynamic amount sync --- */
  function updateAfterpayAmount() {
    var totalEl = document.querySelector('.col-lg-3 .docapp-est-total .docapp-right');
    if (!totalEl) return;
    var totalText = totalEl.textContent.trim().replace(/[^0-9.]/g, '');
    var totalNum = parseFloat(totalText);
    if (isNaN(totalNum) || totalNum <= 0) return;
    document.querySelectorAll('afterpay-placement').forEach(function(el) {
      var current = parseFloat(el.getAttribute('data-amount'));
      if (Math.abs(current - totalNum) > 0.01) {
        el.setAttribute('data-amount', totalNum.toFixed(2));
      }
    });
    // Also sync sticky bar total
    if (totalDiv) totalDiv.textContent = 'Total: $' + totalNum.toFixed(2);
  }

  // Watch the entire sidebar for ANY changes (covers docapp rebuilds)
  var sidebar = document.querySelector('.page-cart .col-lg-3');
  if (sidebar) {
    new MutationObserver(function() {
      setTimeout(updateAfterpayAmount, 300);
      setTimeout(updateAfterpayAmount, 600);
      setTimeout(updateAfterpayAmount, 1000);
    }).observe(sidebar, { childList: true, subtree: true, characterData: true });
  }

  // Also watch cartform for AJAX cart updates
  var cartForm = document.querySelector('#cartform') || document.querySelector('.cart-table');
  if (cartForm) {
    new MutationObserver(function() {
      setTimeout(updateAfterpayAmount, 300);
      setTimeout(updateAfterpayAmount, 600);
      setTimeout(updateAfterpayAmount, 1500);
    }).observe(cartForm, { childList: true, subtree: true, characterData: true });
  }

  updateAfterpayAmount();
})();


/* ==========================================================================
   SKINCARE MEGA MENU — TAG FOR CSS (instant via MutationObserver)
   Adds .sv-skincare-mega class to only the Skincare dropdown so CSS can
   style it as a 3-column grid without affecting other mega menus (Evi Beauty).
   Uses a MutationObserver to tag the element the instant Qikify renders it,
   preventing any flash of the unstyled single-column layout.
   ========================================================================== */
(function() {
  function tagSkincareMega() {
    var found = false;
    document.querySelectorAll('.tmenu_item--root').forEach(function(li) {
      var link = li.querySelector(':scope > .tmenu_item_link');
      if (link && link.textContent.trim().toUpperCase() === 'SKINCARE') {
        var sub = li.querySelector(':scope > .tmenu_submenu');
        if (sub && !sub.classList.contains('sv-skincare-mega')) {
          sub.classList.add('sv-skincare-mega');
        }
        if (sub) found = true;
      }
    });
    return found;
  }

  /* Try immediately, then keep watching.
     Qikify lazy-loads submenus on hover, so the submenu DOM may not exist
     until the user hovers over "Skincare" — could be seconds or minutes.
     The observer stays active until the class is applied. */
  if (!tagSkincareMega()) {
    var observer = new MutationObserver(function() {
      if (tagSkincareMega()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    /* No timeout — Qikify may lazy-load submenus minutes after page load */
  }
})();


/* ==========================================================================
   FORCE CART LINKS TO NAVIGATE TO /cart
   Boost Product Filter minicart intercepts clicks on View Cart buttons
   AND the mobile cart icon, opening a slide-out drawer instead. We use a
   delegated capture-phase listener on `document` so it fires BEFORE any
   Boost handlers, regardless of when Boost loads or re-creates its buttons.
   ========================================================================== */
(function() {
  document.addEventListener('click', function(e) {
    var target = e.target.closest(
      '.btn-view-cart, .boost-pfs-viewcart a, a.mobile-basket, .cart-target a, a[href*="/cart"]'
    );
    if (!target) return;

    /* Intercept: View Cart buttons in minicart dropdown, OR mobile cart icon */
    var text = (target.textContent || '').trim().toLowerCase();
    var isCartNav = target.classList.contains('btn-view-cart')
      || target.closest('.boost-pfs-viewcart')
      || target.classList.contains('mobile-basket')
      || target.closest('.cart-target')
      || text === 'view cart';

    if (!isCartNav) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    window.location.href = '/cart';
  }, true); /* <-- capture phase: fires before element-level handlers */
})();


/* ==========================================================================
   "COMPLETE YOUR ROUTINE" — RELOCATE & CUSTOMIZE FBT WIDGET
   Code Black Belt's FBT widget renders at the bottom of the page by default.
   This script:
   1. Moves it into the product right column (after "More payment options")
   2. Renames title to "Complete Your Routine" with a gold heart icon
   3. Renames button to "Add Bundle to Cart"
   4. Strips "This item:" prefix from the first checkbox label
   Uses a MutationObserver to catch the widget when it loads asynchronously.
   ========================================================================== */
(function() {
  var heartSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C2A57B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-3px;margin-right:8px;flex-shrink:0"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';

  function customizeFBT() {
    var fbt = document.querySelector('.cbb-frequently-bought-container');
    var infoCard = document.querySelector('#sv-info-card');
    var form = document.querySelector('.product-form.product-action');

    if (!fbt || !form) return false;

    /* Already customized? */
    if (fbt.dataset.svCustomized) return true;

    /* 1. Move into product form — above authorized retailer if present, else before trust badges */
    if (!fbt.closest('.product-form')) {
      var authBox = null;
      Array.from(form.children).forEach(function(el) {
        if (!authBox && el !== fbt && el.textContent.indexOf('Authorized Retailer') !== -1) {
          authBox = el;
        }
      });
      if (authBox) {
        form.insertBefore(fbt, authBox);
      } else if (infoCard && infoCard.parentElement === form) {
        form.insertBefore(fbt, infoCard);
      } else {
        form.appendChild(fbt);
      }
    }

    /* 2. Rename title + add gold heart icon + subtext */
    var title = fbt.querySelector('.cbb-frequently-bought-title');
    if (title) {
      title.innerHTML = heartSVG + 'Complete Your Routine';
      if (!fbt.querySelector('.sv-fbt-subtext')) {
        var subtext = document.createElement('div');
        subtext.className = 'sv-fbt-subtext';
        subtext.textContent = 'These items are most frequently paired together.';
        title.insertAdjacentElement('afterend', subtext);
      }
    }

    /* 3. Rename button */
    var btn = fbt.querySelector('.cbb-frequently-bought-add-button');
    if (btn) {
      btn.textContent = 'Add Bundle to Cart';
    }

    /* 4. Strip "This item:", "[Backorder Ships In 7+ Days]" and "[Pre-Order ...]" from labels */
    var labelEls = fbt.querySelectorAll('.cbb-frequently-bought-selector-list .translatable, .cbb-frequently-bought-selector-list .cbb-frequently-bought-selector-link');
    labelEls.forEach(function(el) {
      el.textContent = el.textContent
        .replace(/^This item:\s*/i, '')
        .replace(/\s*\[Backorder Ships [Ii]n \d+\+?\s*Days?\]/g, '')
        .replace(/\s*\[Pre-?Order[^\]]*\]/gi, '')
        .trim();
    });

    /* 5. Move selector-list INTO recommendations-container for CSS order reordering */
    var recsContainer = fbt.querySelector('.cbb-frequently-bought-recommendations-container');
    var selectorList = fbt.querySelector('.cbb-frequently-bought-selector-list');
    if (recsContainer && selectorList && selectorList.parentElement !== recsContainer) {
      recsContainer.appendChild(selectorList);
    }

    fbt.dataset.svCustomized = 'true';
    return true;
  }

  /* Try immediately, then watch for async load */
  if (!customizeFBT()) {
    var observer = new MutationObserver(function() {
      if (customizeFBT()) {
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    /* Safety: stop after 30s */
    setTimeout(function() { observer.disconnect(); }, 30000);
  }
})();